export const extractURLFromIframeData = (iframe) => {
  if (typeof iframe !== 'string') {
    return null;
  }

  const urlRegex = /src="([^"]+)"/;
  const matches = iframe.match(urlRegex);
  return matches ? matches[1] : null;
};
